export default "__VITE_ASSET__BP$0ZXNM__"